/** @file Migrates any stored document to the current schema version, then validates it against DocSchema. */
import { DocSchema, type Doc } from '../doc/schema';
import { FORMAT_VERSION } from '../formatVersion';
import { MIGRATION_STEPS } from './steps.data';
import { throwError } from '../throwError';
import { parseOrThrow } from '../parseOrThrow';

type Migrator = (doc: unknown) => unknown;
/** Concrete migrators keyed by `from` version; each entry in steps.data.ts must have one here. */
const MIGRATORS: Record<number, Migrator> = {};

/** Returns the document at the latest schema version. Throws VALIDATION (see throwError) on invalid input. */
export function migrate(input: unknown): Doc {
  let doc = input;
  const version = typeof doc === 'object' && doc !== null ? (doc as { schemaVersion?: unknown }).schemaVersion : undefined;
  let current = typeof version === 'number' ? version : 0;
  if (current === 0) throwError('VALIDATION', undefined, { path: 'schemaVersion', hint: 'missing schemaVersion' });
  for (const step of MIGRATION_STEPS) {
    if (step.from !== current) continue;
    const run = MIGRATORS[step.from];
    if (!run) throw new Error(`migration ${step.from} has no migrator`);
    doc = run(doc);
    current = step.from + 1;
  }
  if (current !== FORMAT_VERSION.docSchema) {
    throwError('VALIDATION', undefined, { path: 'schemaVersion', hint: `unsupported schema version ${current}` });
  }
  return parseOrThrow(DocSchema, doc);
}
